module.exports = __webpack_public_path__ + "img/myLiveIcon.b8183278.svg";